import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  loading: false,
  saving: false,
};

const getAccountsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getAccountsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getAccountsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    loading: false,
  };
};

const deleteAccountRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const deleteAccountRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const deleteAccountRequestSuccess = (state, payload) => {
  const data = [...state.data].filter((a) => a.id !== payload.data.id);
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const updateAccountRequest = (state, payload) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const updateAccountRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};

const updateAccountRequestSuccess = (state, payload) => {
  return {
    ...state,
    error: null,
    saving: false,
  };
};

const updateCalendarRequest = (state, payload) => {
  return {
    ...state,
    error: null,
    saving: true,
    calendarSaving: payload.data.id,
  };
};
const updateCalendarRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
    calendarSaving: null,
  };
};

const updateCalendarRequestSuccess = (state, payload) => {
  const { id, data } = payload.data;
  const _data = [...state.data].map((account) => {
    if (account.calendars && account.calendars.length > 0) {
      account.calendars = account.calendars.map((calendar) => {
        if (calendar.id === id) {
          calendar = { ...calendar, ...data };
        }
        return calendar;
      });
    }
    return account;
  });
  return {
    ...state,
    data: _data,
    error: null,
    saving: false,
    calendarSaving: null,
  };
};

export default handleActions(
  {
    [types.DELETE_ACCOUNT_REQUEST]: deleteAccountRequest,
    [types.DELETE_ACCOUNT_REQUEST_FAILURE]: deleteAccountRequestFailure,
    [types.DELETE_ACCOUNT_REQUEST_SUCCESS]: deleteAccountRequestSuccess,
    [types.GET_ACCOUNTS_REQUEST]: getAccountsRequest,
    [types.GET_ACCOUNTS_REQUEST_FAILURE]: getAccountsRequestFailure,
    [types.GET_ACCOUNTS_REQUEST_SUCCESS]: getAccountsRequestSuccess,
    [types.UPDATE_ACCOUNT_REQUEST]: updateAccountRequest,
    [types.UPDATE_ACCOUNT_REQUEST_FAILURE]: updateAccountRequestFailure,
    [types.UPDATE_ACCOUNT_REQUEST_SUCCESS]: updateAccountRequestSuccess,
    [types.UPDATE_CALENDAR_REQUEST]: updateCalendarRequest,
    [types.UPDATE_CALENDAR_REQUEST_FAILURE]: updateCalendarRequestFailure,
    [types.UPDATE_CALENDAR_REQUEST_SUCCESS]: updateCalendarRequestSuccess,
  },
  initialState
);
